<template>
  <span class="row">
    <dt class="col-5">{{field}}</dt>
    <dd class="col-7">{{value}}</dd>
  </span>
</template>
<script type="text/javascript">
export default {
  name: 'GIPolicyDetailRow',
  props: {
    field: String,
    value: [String,Number]
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/GIPolicy/components/GIPolicyDetail/GIPolicyDetailRow.vue